<script>
export default {
  name: "CouponDescribe"
}
</script>

<template>
  <div class="coupon-describe">
    <div>
      <!-- <div class="coupon-describe__title coupon1">
        <span>温馨提示</span>
      </div> -->
      <!-- <div class="coupon-describe__desc"> -->
        <!-- <ul> -->
          <!-- <li> -->
            <!-- 1、如您已点击“保存”按钮，且正确输入手机号，会收到优惠券的短信通知，然后到指定机器上进行核销； -->
          <!-- </li> -->
          <!-- <li> -->
            <!-- 1、谨防优惠券丢失的方法有如下几种供您选择： -->
            <!-- 截取屏幕、微信收藏当前页面、拍照答题二维码的图片可再次进入当前页面、分享给其他小伙伴的链接也可以进入当前页面。 -->
          <!-- </li> -->
        <!-- </ul> -->
      <!-- </div> -->
      <!-- <div class="coupon-describe__line my-5"></div> -->
      <div class="coupon-describe__title coupon2">
        <span>活动规则</span>
      </div>
      <div class="coupon-describe__desc">
        <ul>
          <li>
            1、用户使用微信扫码进行答题后，也需要同样用微信在机器上进行商品支付。
          </li>
          <li>2、优惠券码会在用户扫码支付后自动使用。</li>
          <li>
            3、活动期间，用户认真答题且不被系统甄别题甄别的情况下，成功答题的用户可获得优惠券奖励。
          </li>
          <!-- <li>
            4、如您“保存”当前优惠券码，优惠券会以短信的形式发放出去，方便保存。可能有延迟，请耐心等待。
          </li> -->
          <li>
            4、活动期间，同一用户只能在每一个问卷中获取一张优惠券，重复答题无效。如果某问卷可多次答题，请先使用已获得的优惠券，答题后可再次获得优惠券。
          </li>
          <li>
            5、查看历史优惠券码，请点击“历史优惠券”按钮，可以帮助您发现没有使用的优惠券码。
          </li>
          <li>6、研酷设备选择商品后，扫码支付时（注意此时的扫码支付，需要与答题人为同一人且同一个微信），可以手动输入获得的6位优惠码进行核销；系统也会自动选取一张最新的优惠码自动核销，此时用户请注意付款页面的提示。</li>
          <li>7、如有疑问，请咨询 客服:15311678025。</li>
        </ul>
      </div>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.coupon-describe {
  background: #FFF1E5;
  border-radius: 8px;
  padding: 12px;

  &>div {
    border: 0.5px solid #FF7700;
    border-radius: 4px;
    padding: 12px;
  }


  &__title {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    text-align: center;
    line-height: 22px;
    margin-bottom: 12px;


    &>span {
      position: relative;

      &::before,
      &::after {
        content: " ";
        position: absolute;
        background-image: url("~@/assets/img/svg/star.svg");
        width: 12px;
        height: 12px;
        top: 2px;
      }

      &::before {
        left: -24px;
      }

      &::after {
        right: -24px;
      }
    }

  }

  &__desc {
    font-size: 14px;
    color: #000000;
    line-height: 22px;

    li {
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__line {
    border-bottom: 1px dashed #FF7700;
  }

  .coupon1 {
    position: relative;

    &::after {
      content: " ";
      position: absolute;
      right: -24px;
      top: -24px;
      background-image: url("~@/assets/img/answer/coupon1.png");
      background-repeat: no-repeat;
      background-size: contain;
      width: 51px;
      height: 46px;
    }
  }

  .coupon2 {
    position: relative;

    &::before {
      content: " ";
      position: absolute;
      left: -24px;
      top: -24px;
      background-image: url("~@/assets/img/answer/coupon2.png");
      background-size: contain;
      background-repeat: no-repeat;
      width: 51px;
      height: 46px;
    }
  }
}
</style>